import type { Consumer } from "@rails/actioncable";
import { createConsumer } from "@rails/actioncable";

let consumer: Consumer | null = null;

export function getConsumer(): Consumer {
  if (!consumer) {
    const meta = document.querySelector<HTMLMetaElement>(
      'meta[name="action-cable-url"]',
    );
    const url = meta?.content ?? "/cable";
    consumer = createConsumer(url);
  }
  return consumer;
}

// HMR support for development
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    consumer?.disconnect();
    consumer = null;
  });
}
